import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificado-curso-excel-basico',
  templateUrl: './certificado-curso-excel-basico.component.html',
  styleUrls: ['./certificado-curso-excel-basico.component.scss']
})
export class CertificadoCursoExcelBasicoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
